module.exports = __webpack_public_path__ + "static/media/logo.ef8f7595.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Signup/logo.png
// module id = 2785
// module chunks = 0